import React from "react";
import styles from "./Curewell.module.scss";
import qrCode from "../../../../images/qr.png";
import regBarcode from "../../../../images/registartinbarcode.png";
import signature from "../../../../images/Picture5.jpg";

const Curewell = ({
  clinic,
  address,
  qrCodeUrl,
  item,
  referrer,
  selectedItem,
  reportType = "report", 
}) => {

  const isInvoice = reportType === "invoice";
  const isReceipt = reportType === "receipt";
  const isReport = reportType === "report";
  const source =
    selectedItem?.appointmentDetails ||
    selectedItem?.appointment ||
    selectedItem ||
    {};

  const formatDate = (date, shortYear = false) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: shortYear ? "2-digit" : "numeric",
    });
  };

  const invoiceHeaderLeft = () => (
    <div className={styles.Header}>
      <div className={styles.headerLogo}>
        <img
          src={clinic?.hospitalInfo?.pdfHeader}
          alt="logo"
          crossOrigin="anonymous"
        />
        <p>A Unit of Advanced Curewell Laboratory & diagnostics pvt. ltd.</p>
      </div>

      <div className={styles.headerAddress}>
        <p>{address}</p>
        <p>
          <span>Phone :</span> {clinic?.phone}
        </p>
        <p>
          <span>Email :</span> {clinic?.clinicEmail}
        </p>
        <p>
          <span>Website :</span> {clinic?.hospitalInfo?.web_address}
        </p>
      </div>

      {clinic?.hospitalInfo?.displayISOlogo && (
        <div className={styles.isoLogo}>
          <img
            src={clinic?.hospitalInfo?.ISOLogo}
            alt="isoLogo"
            crossOrigin="anonymous"
          />
        </div>
      )}
    </div>
  );


  const invoiceHeaderRight = () => (
    <div className={styles.Header} style={{ padding: "0.9rem 0.7rem 0 0" }}>
      <div className={styles.headerAddress} style={{ borderLeft: "none" }}>
        <p>{address}</p>
        <p>
          <span>Phone :</span> {clinic?.phone}
        </p>
        <p>
          <span>Email :</span> {clinic?.clinicEmail}
        </p>
        <p>
          <span>Website :</span> {clinic?.hospitalInfo?.web_address}
        </p>
      </div>

      <div className={styles.headerLogo}>
        <img
          src={clinic?.hospitalInfo?.pdfHeader}
          alt="logo"
          crossOrigin="anonymous"
        />
        <p>A Unit of Advanced Curewell Laboratory & diagnostics pvt. ltd.</p>
      </div>

      {clinic?.hospitalInfo?.displayISOlogo && (
        <div className={styles.isoLogo}>
          <img
            src={clinic?.hospitalInfo?.ISOLogo}
            alt="isoLogo"
            crossOrigin="anonymous"
          />
        </div>
      )}
    </div>
  );

  const invoiceHeaderCenter = () => (
    <div className={styles.Header}>
      {clinic?.hospitalInfo?.displayISOlogo && (
        <div className={styles.isoLogo}>
          <img
            src={clinic?.hospitalInfo?.ISOLogo}
            alt="isoLogo"
            crossOrigin="anonymous"
          />
        </div>
      )}

      <div className={styles.headerLogo}>
        <img
          src={clinic?.hospitalInfo?.pdfHeader}
          alt="logo"
          crossOrigin="anonymous"
        />
        <p>A Unit of Advanced Curewell Laboratory & diagnostics pvt. ltd.</p>
      </div>

      <div className={styles.headerAddress}>
        <p>{address}</p>
        <p>
          <span>Phone :</span> {clinic?.phone}
        </p>
        <p>
          <span>Email :</span> {clinic?.clinicEmail}
        </p>
        <p>
          <span>Website :</span> {clinic?.hospitalInfo?.web_address}
        </p>
      </div>
    </div>
  );



  const data = (() => {
    if (selectedItem?.tests) return selectedItem;
    if (selectedItem?.appointmentDetails?.tests)
      return selectedItem.appointmentDetails;
    return selectedItem || {};
  })();

  return (
    <div className={styles.MainDiv}>
      {clinic?.hospitalInfo?.headerAlignment === "left" && invoiceHeaderLeft()}
      {clinic?.hospitalInfo?.headerAlignment === "right" &&
        invoiceHeaderRight()}
      {clinic?.hospitalInfo?.headerAlignment === "center" &&
        invoiceHeaderCenter()}

      {/* ================= HEADER DETAILS ================= */}
      <div className={styles.headerDetails}>
        <div className={styles.headerDetailsLeft}>
          <p>
            <span className={styles.bold}>Name</span>:{" "}
            {selectedItem?.patientId?.userId?.name ||
              selectedItem?.patientName ||
              "N/A"}
          </p>

          <p>
            <span className={styles.bold}>Patient ID</span>:{" "}
            {selectedItem?.patientId?.UHID ||
              selectedItem?.patientId?._id ||
              "N/A"}
          </p>

          {(isInvoice || isReceipt) && (
            <>
              <p>
                <span className={styles.bold}>Email</span>:{" "}
                {selectedItem?.patientId?.userId?.email || "N/A"}
              </p>
              <p>
                <span className={styles.bold}>Phone</span>:{" "}
                {selectedItem?.patientId?.userId?.phone || "N/A"}
              </p>
            </>
          )}

          {/* {isReport && (
            <p>
              <span className={styles.bold}>Refer By</span>:{" "}
              {referrer?.name || "N/A"}
            </p>
          )} */}

          <p>
            <span className={styles.bold}>Date</span> :{" "}
            {formatDate(selectedItem?.appDate || selectedItem?.createdAt)}
          </p>
        </div>

        {/* {isReport && (
          <div className={styles.headerDetailsRight}>
            <p>
              <span className={styles.bold}>Reg.No</span>:{" "}
              <img src={regBarcode} alt="" crossOrigin="anonymous" />
            </p>
            <p>
              <span className={styles.bold}>Registration Date</span> :{" "}
              {formatDate(selectedItem?.createdDt, true)}
            </p>
            <p>
              <span className={styles.bold}>Collection Date</span> :{" "}
              {formatDate(selectedItem?.createdDt, true)}
            </p>
            <p>
              <span className={styles.bold}>Sample Receive Date</span> :{" "}
              {formatDate(selectedItem?.updatedDt, true)}
            </p>
          </div>
        )} */}
      </div>

      <div className={styles.waterMark}>
        <img
          src={clinic?.hospitalInfo?.waterMark}
          alt=""
          crossOrigin="anonymous"
        />
      </div>

      {/* ================= TABLE LOGIC ================= */}
      <div className={styles.tableDiv}>
        {(() => {
          const currentData =
            selectedItem && Object.keys(selectedItem).length
              ? selectedItem
              : item || {};
          const source =
            currentData?.appointmentDetails ||
            currentData?.appointment ||
            currentData ||
            {};

          // 1. Combine all possible service arrays including consultationDetails
          const services = [
            ...(source?.tests || []),
            ...(source?.profiles || []),
            ...(source?.skinServices || []),
            ...(source?.dentalServices || []),
            ...(source?.hairServices || []),
            ...(source?.generalServices || []),
            ...(source?.physiotherapyService || []),
            ...(source?.radioServices || []),
            ...(source?.healthScreeningDetails || []),
            ...(source?.healthPackageDetails || []),
            ...(source?.consultationDetails || []),
          ];

          if (!services.length) return null;

          let grandTotal = 0;

          return (
            <>
              <table className={styles.invoiceTable}>
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Item Name</th>
                    <th>Rate</th>
                    <th>Tax</th>
                    <th>SGST</th>
                    <th>CGST</th>
                    <th>Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {services?.map((service, index) => {
                    // 2. FIXED ITEM NAME LOGIC: Check for consultationType fallback
                    const name =
                      service?.testId?.testName ||
                      service?.profileId?.profileName ||
                      service?.serviceName ||
                      // Path from your JSON: consultationDetails -> consultationId -> timeSlot -> consultationType
                      service?.consultationId?.timeSlot?.consultationType ||
                      "Consultation";

                    // 3. FIXED RATE LOGIC: Pull 'price' from your JSON response
                    const price = Number(
                      service?.price || service?.consultationFee || 0,
                    );

                    const tax = service?.tax ?? service?.testId?.tax ?? 0;
                    const sgst = tax / 2;
                    const cgst = tax / 2;

                    const total = price;
                    grandTotal += price;

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td style={{ textAlign: "left" }}>{name}</td>
                        <td>Rs {price.toFixed(2)}</td>
                        <td>{Number(tax).toFixed(2)}%</td>
                        <td>{sgst.toFixed(2)}%</td>
                        <td>{cgst.toFixed(2)}%</td>
                        <td>Rs {total.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div style={{ marginTop: "20px" }}>
                {(() => {
                  const paidAmount =
                    Number(item?.receiptId?.paidAmount) ||
                    Number(source?.paidAmount) ||
                    0;
                  const discount =
                    Number(item?.receiptId?.discountPrice) ||
                    Number(source?.discountAmount) ||
                    0;
                  const balanceDue = grandTotal - paidAmount - discount;

                  return (
                    <>
                      <p>
                        <strong>Total Amount:</strong> Rs{" "}
                        {grandTotal.toFixed(2)}
                      </p>
                      <p>
                        <strong>Discount:</strong> Rs {discount.toFixed(2)}
                      </p>
                      <p>
                        <strong>Paid Amount:</strong> Rs {paidAmount.toFixed(2)}
                      </p>
                      <p
                        style={{
                          fontSize: "1.1rem",
                          borderTop: "1px solid #eee",
                          paddingTop: "5px",
                        }}
                      >
                        <strong>Balance Due:</strong> Rs {balanceDue.toFixed(2)}
                      </p>
                    </>
                  );
                })()}
              </div>
            </>
          );
        })()}
      </div>

      {/* ================= FOOTER ================= */}
      <div className={styles.footer}>
        <div className={styles.footerMainDiv}>
          {[1, 2, 3].map((i) => (
            <div key={i} className={styles.footerRight}>
              <img src={signature} alt="" crossOrigin="anonymous" />
              <p className={styles.bold}>Signature</p>
            </div>
          ))}
        </div>

        <div className={styles.footerCenter}>
          <p className={styles.bold}>End Of Report</p>
          <p className={styles.page}>Page: 1 | 1</p>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.footerLeft}>
            <img src={qrCodeUrl || qrCode} alt="" crossOrigin="anonymous" />
          </div>
          <div className={styles.footerRight}>
            <p>
              - The Results of the Supplied Samples are Dependent upon the
              Quality of the sample received
            </p>
            <p>
              - The Result should be Clinically correlated and the unexpected
              result may be repeated
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Curewell;
